import {Button, Grid, Surface, Tab, Table, Text, useTheme} from "tmwx-design-web/src";
import {useEffect, useMemo, useState} from "react";
import {isEmpty} from "gui-common/appHelper";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "gui-common/redux/store";
import {ControlParam, Event, MetricParam, Range} from "gui-common/redux/data/metricParam";
import {usePermissions} from "tmwx-design-common";
import {ColumnDef} from "@tanstack/react-table";
import {useTranslation} from "react-i18next";
import {getEventList, getMetricListParam, getRangeList} from "gui-common/redux/action/efe/metricParamActions";
import {useSearchParams} from "react-router-dom";
import constants from "gui-common/constants.json";
import {metricParamActions} from "gui-common/redux/slice/efe/metricParamSlice";
import ControlParamSearchModal from "../../components/efe/ControlParamSearchModal";
import RangeTable from "../../components/efe/RangeTable";

const MetricParams = () => {
    const {t} = useTranslation()
    const {padding, roundness} = useTheme()
    const dispatch: any = useDispatch()
    const {hasRights} = usePermissions()
    const [label, setLabel] = useState<string>('');
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedControlParam = useSelector<RootState, ControlParam>(state => state.metricParam.selectedControlParam)
    const metricList = useSelector<RootState, MetricParam[]>(state => state.metricParam.metricList);
    const eventList = useSelector<RootState, Event[]>(state => state.metricParam.eventList);
    const rangeList = useSelector<RootState, Range[]>(state => state.metricParam.rangeList);
    const loading = useSelector<RootState, boolean>(state => state.metricParam.loading);

    useEffect(() => {
        if (!isEmpty(selectedControlParam.cpsName) && !isEmpty(selectedControlParam.cpsTag) && !isEmpty(selectedControlParam.cpsVersion)) {
            setLabel(selectedControlParam.cpsName + ' - ' + selectedControlParam.cpsTag + ' (' + selectedControlParam.cpsVersion + ')')
            const cpsTag = selectedControlParam.cpsTag
            const cpsName = selectedControlParam.cpsName
            const cpsVersion = selectedControlParam.cpsVersion
            setSearchParams({ cpsTag, cpsName, cpsVersion });

            if (hasRights(["efe_metric_param_view"])) {
                dispatch(getMetricListParam(selectedControlParam.cpsTag))
                dispatch(getEventList(selectedControlParam.cpsTag))
                dispatch(getRangeList(selectedControlParam.cpsTag))
            }
        }
    }, [selectedControlParam])

    useEffect(() => {
        const cpsTag = localStorage.getItem(constants.CPS_TAG);
        const cpsName = localStorage.getItem(constants.CPS_NAME);
        const cpsVersion = localStorage.getItem(constants.CPS_VERSION);

        if (cpsTag != null  && cpsName != null && cpsVersion != null)  {
            dispatch(metricParamActions.setSelectedControlParam({
                cpsTag: cpsTag,
                cpsName: cpsName,
                cpsVersion: cpsVersion
            }))
        }
    }, [dispatch])

    useEffect(() => {
        const searchCpsTag = searchParams.get("cpsTag") as string;
        const searchCpsName = searchParams.get("cpsName") as string;
        const searchCpsVersion = searchParams.get("cpsVersion") as string;

        if (searchCpsTag != null && searchCpsName != null && searchCpsVersion != null)  {
            localStorage.setItem(constants.CPS_TAG, searchCpsTag);
            localStorage.setItem(constants.CPS_NAME, searchCpsName);
            localStorage.setItem(constants.CPS_VERSION, searchCpsVersion);

            dispatch(metricParamActions.setSelectedControlParam({
                cpsTag: searchCpsTag,
                cpsName: searchCpsName,
                cpsVersion: searchCpsVersion
            }))
        }
    }, [searchParams])

    // const columns = useMemo<ColumnDef<Register>[]>(
    //     () => [
    //         {
    //             accessorKey: 'dteTemplateName',
    //             meta: t('efe.register.podTemplate'),
    //             size: 70,
    //             header: () => <Text bold>{t('efe.register.podTemplate')}</Text>,
    //         },
    //         {
    //             accessorKey: 'regName',
    //             meta: t('efe.register.name'),
    //             size: 50,
    //             header: () => <Text bold>{t('efe.register.name')}</Text>,
    //         },
    //         {
    //             accessorKey: 'regAddress',
    //             meta: t('efe.register.address'),
    //             size: 50,
    //             header: () => <Text bold>{t('efe.register.address')}</Text>,
    //         },
    //         {
    //             accessorKey: 'regUnitOfMeasurement',
    //             meta: t('efe.register.unitOfMeasurement'),
    //             header: () => <Text bold>{t('efe.register.unitOfMeasurement')}</Text>,
    //         },
    //         {
    //             accessorKey: 'regDataType',
    //             meta: t('efe.register.dataType'),
    //             header: () => <Text bold>{t('efe.register.dataType')}</Text>,
    //         },
    //         {
    //             accessorKey: 'regRegisterType',
    //             meta: t('efe.register.registerType'),
    //             header: () => <Text bold>{t('efe.register.registerType')}</Text>,
    //         },
    //         {
    //             accessorKey: 'regRegisterCount',
    //             meta: t('efe.register.registerCount'),
    //             header: () => <Text bold>{t('efe.register.registerCount')}</Text>,
    //         },
    //         {
    //             accessorKey: 'regRegisterGroup',
    //             meta: t('efe.register.registerGroup'),
    //             header: () => <Text bold>{t('efe.register.registerGroup')}</Text>,
    //         },
    //         {
    //             accessorKey: 'regReadOnce',
    //             meta: t('efe.register.readOnce'),
    //             header: () => <Text bold>{t('efe.register.readOnce')}</Text>,
    //             cell: ({ row }) => (
    //                 (row.original.regReadOnce) && (
    //                     < Button
    //                         iconLeft={'check'}
    //                         status={'success'}
    //                         size='small'
    //                         onPress={() => {
    //                         }}
    //                     />
    //                 )
    //             ),
    //             enableColumnOrdering: false,
    //             enableColumnActions: false,
    //             enableSorting: false,
    //             enableResizing: false,
    //             enableHiding: false,
    //         },
    //         {
    //             accessorKey: 'regDescription',
    //             meta: t('efe.register.desc'),
    //             size: 500,
    //             header: () => <Text bold>{t('efe.register.desc')}</Text>,
    //         }
    //     ],
    //     [dispatch, hasRights, padding, t]
    // );

    const columnsMetric = useMemo<ColumnDef<MetricParam>[]>(
        () => [
            {
                accessorKey: 'mtrDeviceTypeTag',
                meta: t('efe.metric.deviceType'),
                header: () => <Text bold>{t('efe.metric.deviceType')}</Text>,
            },
            {
                accessorKey: 'mtrMetricName',
                meta: t('name'),
                header: () => <Text bold>{t('name')}</Text>,
            },
            {
                accessorKey: 'mttDefaultSourceId',
                meta: t('efe.metric.channelName'),
                header: () => <Text bold>{t('efe.metric.channelName')}</Text>,
            },
            {
                accessorKey: 'mttMetricDataType',
                meta: t('efe.register.dataType'),
                header: () => <Text bold>{t('efe.register.dataType')}</Text>,
            },
            {
                accessorKey: 'mtt3phaseMode',
                meta: t('efe.metric.phase3'),
                header: () => <Text bold>{t('efe.metric.phase3')}</Text>,
                cell: ({ row }) => (
                    (row.original.mtt3phaseMode) && (
                        < Button
                            iconLeft={'check'}
                            status={'success'}
                            size='small'
                            onPress={() => {
                            }}
                        />
                    )
                ),
                enableColumnOrdering: false,
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                enableHiding: false,
            },
            {
                accessorKey: 'mtrStatTypeGrpMin',
                meta: t('efe.metric.min'),
                header: () => <Text bold>{t('efe.metric.min')}</Text>,
                cell: ({ row }) => (
                    (row.original.mtrStatTypeGrpMin) && (
                        < Button
                            iconLeft={'check'}
                            status={'success'}
                            size='small'
                            onPress={() => {
                            }}
                        />
                    )
                ),
                enableColumnOrdering: false,
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                enableHiding: false,
            },
            {
                accessorKey: 'mtrStatTypeGrpMax',
                meta: t('efe.metric.max'),
                header: () => <Text bold>{t('efe.metric.max')}</Text>,
                cell: ({ row }) => (
                    (row.original.mtrStatTypeGrpMax) && (
                        < Button
                            iconLeft={'check'}
                            status={'success'}
                            size='small'
                            onPress={() => {
                            }}
                        />
                    )
                ),
                enableColumnOrdering: false,
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                enableHiding: false,
            },
            {
                accessorKey: 'mtrStatTypeGrpAvg',
                meta: t('efe.metric.avg'),
                header: () => <Text bold>{t('efe.metric.avg')}</Text>,
                cell: ({ row }) => (
                    (row.original.mtrStatTypeGrpAvg) && (
                        < Button
                            iconLeft={'check'}
                            status={'success'}
                            size='small'
                            onPress={() => {
                            }}
                        />
                    )
                ),
                enableColumnOrdering: false,
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                enableHiding: false,
            },
            {
                accessorKey: 'mtrStatTypeGrpSum',
                meta: t('efe.metric.sum'),
                header: () => <Text bold>{t('efe.metric.sum')}</Text>,
                cell: ({ row }) => (
                    (row.original.mtrStatTypeGrpSum) && (
                        < Button
                            iconLeft={'check'}
                            status={'success'}
                            size='small'
                            onPress={() => {
                            }}
                        />
                    )
                ),
                enableColumnOrdering: false,
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                enableHiding: false,
            },
            {
                accessorKey: 'mtrStatTypeGrpWavg',
                meta: t('efe.metric.wavg'),
                header: () => <Text bold>{t('efe.metric.wavg')}</Text>,
                cell: ({ row }) => (
                    (row.original.mtrStatTypeGrpWavg) && (
                        < Button
                            iconLeft={'check'}
                            status={'success'}
                            size='small'
                            onPress={() => {
                            }}
                        />
                    )
                ),
                enableColumnOrdering: false,
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                enableHiding: false,
            },
            {
                accessorKey: 'mtrStatTypeGrpLast',
                meta: t('efe.metric.last'),
                header: () => <Text bold>{t('efe.metric.last')}</Text>,
                cell: ({ row }) => (
                    (row.original.mtrStatTypeGrpLast) && (
                        < Button
                            iconLeft={'check'}
                            status={'success'}
                            size='small'
                            onPress={() => {
                            }}
                        />
                    )
                ),
                enableColumnOrdering: false,
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                enableHiding: false,
            },
            {
                accessorKey: 'mtrStatTypeGrpOnce',
                meta: t('efe.metric.once'),
                header: () => <Text bold>{t('efe.metric.once')}</Text>,
                cell: ({ row }) => (
                    (row.original.mtrStatTypeGrpOnce) && (
                        < Button
                            iconLeft={'check'}
                            status={'success'}
                            size='small'
                            onPress={() => {
                            }}
                        />
                    )
                ),
                enableColumnOrdering: false,
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                enableHiding: false,
            },
            {
                accessorKey: 'mtrStatTypeGrpData',
                meta: t('data'),
                header: () => <Text bold>{t('data')}</Text>,
                cell: ({ row }) => (
                    (row.original.mtrStatTypeGrpData) && (
                        < Button
                            iconLeft={'check'}
                            status={'success'}
                            size='small'
                            onPress={() => {
                            }}
                        />
                    )
                ),
                enableColumnOrdering: false,
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                enableHiding: false,
            },
            {
                accessorKey: 'mttDescription',
                meta: t('efe.register.desc'),
                size: 500,
                header: () => <Text bold>{t('efe.register.desc')}</Text>,
            }
        ],
        [dispatch, hasRights, padding, t]
    );

    const columnsEvent = useMemo<ColumnDef<Event>[]>(
        () => [
            {
                accessorKey: 'evtEventTag',
                meta: t('efe.event.tag'),
                size: 50,
                header: () => <Text bold>{t('efe.event.tag')}</Text>,
            },
            {
                accessorKey: 'evtEventType',
                meta: t('efe.event.type'),
                size: 50,
                header: () => <Text bold>{t('efe.event.type')}</Text>,
            },
            {
                accessorKey: 'evtMetricName',
                meta: t('efe.event.metricName'),
                header: () => <Text bold>{t('efe.event.metricName')}</Text>,
            },
            {
                accessorKey: 'evtMetricDataType',
                meta: t('efe.register.dataType'),
                header: () => <Text bold>{t('efe.register.dataType')}</Text>,
            },
            {
                accessorKey: 'evtEventTypeClear',
                meta: t('efe.event.typeClear'),
                header: () => <Text bold>{t('efe.event.typeClear')}</Text>,
            },
            {
                accessorKey: 'evtAutoClearMsec',
                meta: t('efe.event.clearMsec'),
                header: () => <Text bold>{t('efe.event.clearMsec')}</Text>,
            },
            {
                accessorKey: 'evtParamDescription',
                meta: t('efe.event.paramDesc'),
                header: () => <Text bold>{t('efe.event.paramDesc')}</Text>,
            },
            {
                accessorKey: 'evtDescription',
                meta: t('efe.register.desc'),
                size: 500,
                header: () => <Text bold>{t('efe.register.desc')}</Text>,
            }
        ],
        [dispatch, hasRights, padding, t]
    );

    const columnsRange = useMemo<ColumnDef<Range>[]>(
        () => [
            {
                accessorKey: 'ranSourceId',
                meta: t('efe.rangeList.register'),
                header: () => <Text bold>{t('efe.rangeList.register')}</Text>,
            },
            {
                accessorKey: 'ranMinAlertEvtMetricName',
                meta: t('efe.rangeList.minAlertName'),
                header: () => <Text bold>{t('efe.rangeList.minAlertName')}</Text>,
            },
            {
                accessorKey: 'ranMinAlertValue',
                meta: t('efe.rangeList.minValue'),
                header: () => <Text bold>{t('efe.rangeList.minValue')}</Text>,
            },
            {
                accessorKey: 'ranMaxAlertEvtMetricName',
                meta: t('efe.rangeList.maxAlertName'),
                header: () => <Text bold>{t('efe.rangeList.maxAlertName')}</Text>,
            },
            {
                accessorKey: 'ranMaxAlertValue',
                meta: t('efe.rangeList.maxValue'),
                header: () => <Text bold>{t('efe.rangeList.maxValue')}</Text>,
            },
            {
                accessorKey: 'ranOnHysteresisMsec',
                meta: t('efe.rangeList.onHysteresisMsec'),
                header: () => <Text bold>{t('efe.rangeList.onHysteresisMsec')}</Text>,
            },
            {
                accessorKey: 'ranOffHysteresisMsec',
                meta: t('efe.rangeList.offHysteresisMsec'),
                header: () => <Text bold>{t('efe.rangeList.offHysteresisMsec')}</Text>,
            }
        ],
        [dispatch, hasRights, padding, t]
    );

    return (
        <Surface style={{height: '100vh', paddingTop: 8, paddingBottom: 8}}>
            <Grid.Container style={{borderRadius: roundness}} maxWidth='xl' elevation={0} centered>
                <Grid.Col m={6} lg={6} xl={6}>
                    <ControlParamSearchModal label={label}/>
                </Grid.Col>

                <Grid.Col>
                    {!isEmpty(selectedControlParam) &&
                        <Tab
                            elevation={0}
                            contentMode='keep'
                            menuItems={[
                                // {
                                //     title: t('efe.registers'),
                                //     icon: 'info_outlined',
                                //     component: (
                                //         <Table
                                //             id='REGISTER_TABLE'
                                //             columns={columns}
                                //             data={registerList}
                                //             loading={loading}
                                //             dense
                                //             useColumnVisibility
                                //             labels={{
                                //                 add: t('add'),
                                //                 deletePreferences: t('deletePreferences'),
                                //                 jumpHere: t('jumpHere'),
                                //                 page: t('page'),
                                //                 refresh: t('refresh'),
                                //                 row: t('row'),
                                //                 rowsSelected: t('rowsSelected'),
                                //                 savePreferencies: t('savePreferences'),
                                //                 searchData: t('searchData'),
                                //                 selectCurrentPageData: t('selectCurrentPageData'),
                                //                 showAll: t('showAll'),
                                //                 sizing: t('sizing')
                                //             }}
                                //         />
                                //     )
                                // },
                                {
                                    title: t('efe.metrics'),
                                    icon: 'info_outlined',
                                    component: (
                                        <Table
                                            id='METRIC_TABLE'
                                            columns={columnsMetric}
                                            data={metricList}
                                            loading={loading}
                                            dense
                                            useColumnVisibility
                                            labels={{
                                                add: t('add'),
                                                deletePreferences: t('deletePreferences'),
                                                jumpHere: t('jumpHere'),
                                                page: t('page'),
                                                refresh: t('refresh'),
                                                row: t('row'),
                                                rowsSelected: t('rowsSelected'),
                                                savePreferencies: t('savePreferences'),
                                                searchData: t('searchData'),
                                                selectCurrentPageData: t('selectCurrentPageData'),
                                                showAll: t('showAll'),
                                                sizing: t('sizing')
                                            }}
                                        />
                                    )
                                },
                                {
                                    title: t('events'),
                                    icon: 'info_outlined',
                                    component: (
                                        <Table
                                            id='EVENT_TABLE'
                                            columns={columnsEvent}
                                            data={eventList}
                                            loading={loading}
                                            dense
                                            useColumnVisibility
                                            labels={{
                                                add: t('add'),
                                                deletePreferences: t('deletePreferences'),
                                                jumpHere: t('jumpHere'),
                                                page: t('page'),
                                                refresh: t('refresh'),
                                                row: t('row'),
                                                rowsSelected: t('rowsSelected'),
                                                savePreferencies: t('savePreferences'),
                                                searchData: t('searchData'),
                                                selectCurrentPageData: t('selectCurrentPageData'),
                                                showAll: t('showAll'),
                                                sizing: t('sizing')
                                            }}
                                        />
                                    )
                                },
                                {
                                    title: t('efe.range'),
                                    icon: 'info_outlined',
                                    component: (
                                        <RangeTable cpsTag={selectedControlParam.cpsTag}/>
                                    )
                                }
                            ]}
                        />
                    }
                </Grid.Col>
            </Grid.Container>
        </Surface>
    )
}

export default MetricParams;